import { render, staticRenderFns } from "./ProductCopyPopupIframe.vue?vue&type=template&id=ec54b496&"
import script from "./ProductCopyPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductCopyPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports